<template>
  <div class="home" style="height: 100%;">
    <el-container style="height: 100%; border: 1px solid #eee">

      <el-aside width="200px" style="background-color: rgb(255,254,251)">
        <img width="190px" height="190px" alt="" src="https://www.tcpcat.com/ait/axw/axwlogo.png">
        <!-- <div style="text-align: center;font-size: 30px;margin-top: 20px;margin-bottom: 20px;">
          艾智能科技</div> -->
        <!-- <div style="text-align: center;font-size: 20px;font-family: '隶书', SimLi;margin-top: 20px;margin-bottom: 20px;">
          艾灸设备管理平台</div> -->
        <el-menu :default-openeds="['2','3']">
          <el-menu-item index="1" @click="switchDeviceComp('', '1')"><i class="el-icon-monitor"></i>全部设备</el-menu-item>

          <el-submenu index="2">
            <template slot="title"><i class="el-icon-collection-tag"></i>类别筛选</template>
            <el-menu-item index="2-1" @click="switchDeviceComp('艾灸床LED', '2-1')"><i
                class="el-icon-cpu"></i>艾灸床按键</el-menu-item>
            <el-menu-item index="2-2" @click="switchDeviceComp('艾灸床', '2-2')"><i
                class="el-icon-thumb"></i>艾灸床触屏</el-menu-item>
                <el-menu-item index="2-3" @click="switchDeviceComp('透灸仪', '2-3')"><i
                class="el-icon-wind-power"></i>透灸仪</el-menu-item>
            <el-menu-item index="2-4" @click="switchDeviceComp('熏蒸床', '2-4')"><i
                class="el-icon-hot-water"></i>熏蒸床</el-menu-item>

          </el-submenu>

          <el-submenu index="3">
            <template slot="title"><i class="el-icon-connection"></i>状态筛选</template>
            <!-- <el-menu-item index="2-1" @click="switchDeviceComp('', '2-1')"><i
                class="el-icon-finished"></i>全部设备</el-menu-item> -->
            <el-menu-item index="3-2" @click="switchDeviceComp('在线', '3-2')"><i
                class="el-icon-circle-check"></i>在线设备</el-menu-item>
            <el-menu-item index="3-3" @click="switchDeviceComp('运行', '3-3')"><i
                class="el-icon-star-off"></i>运行设备</el-menu-item>
            <el-menu-item index="3-4" @click="switchDeviceComp('离线', '3-4')"><i
                class="el-icon-circle-close"></i>离线设备</el-menu-item>
          </el-submenu>

          <el-menu-item index="4" v-if="pg_list.create_user" @click="switchUserComp"><i
              class="el-icon-user"></i>账号管理</el-menu-item>
          <!-- <el-menu-item index="5" @click="openMap"><i class="el-icon-map-location"></i>设备分布地图</el-menu-item> -->

          <el-submenu index="6">
            <template slot="title"><i class="el-icon-setting"></i>系统设定</template>
            <!-- <el-menu-item v-if="pg_list.offline_recharge" index="6-1"
              @click="OfflineDialog = true; OfflineCommited = false"><i class="el-icon-key"></i>密码离线充次</el-menu-item> -->
            <el-menu-item index="6-2" @click="openSetting"><i class="el-icon-lock"></i>修改后台密码</el-menu-item>
            <el-menu-item index="6-3" @click="exit"><i class="el-icon-error"></i>退出系统</el-menu-item>

          </el-submenu>

        </el-menu>
      </el-aside>

      <el-container>
        <!-- 修改密码 Start -->
        <el-dialog title="修改密码" :visible.sync="SettingDialog" width="500px">

          <el-form>
            <el-form-item label="当前密码" label-width="80px">
              <el-input v-model="InputOldPassword" show-password autocomplete="off" maxlength="32"></el-input>
            </el-form-item>
            <el-form-item label="新密码" label-width="80px">
              <el-input v-model="InputPassword1" show-password autocomplete="off" maxlength="32"></el-input>
            </el-form-item>
            <el-form-item label="确认密码" label-width="80px">
              <el-input v-model="InputPassword2" show-password autocomplete="off" maxlength="32"></el-input>
            </el-form-item>
            <el-form-item label="" label-width="80px">
              <el-button type="primary" @click="ChangePassword">修 改 密 码</el-button>
            </el-form-item>
          </el-form>

        </el-dialog>
        <!-- 修改密码 END -->

        <!-- 离线充次 Start -->
        <el-dialog title="离线充次" :visible.sync="OfflineDialog" width="440px">
          <el-form>
            <el-form-item label="离线充次编号" label-width="120px">
              <el-input type="text" placeholder="请输入10位离线充次编号" v-model="OffCode" maxlength="10"
                show-word-limit></el-input>
            </el-form-item>

            <div v-if="OfflineCommited">
              <div style="text-align: center;font-size: 36px">充次密码：{{ OffResult }}</div>
              <div style="margin: 10px">设备编号的后3位：{{ OffCid }}</div>
              <div style="margin: 10px">客户输入充值次数：{{ OffName }}</div>
            </div>


            <el-alert v-if="!OfflineCommited" title="将用户屏幕上的10位<离线充次编号>输入，点击获取密码" type="success" :closable="false">
            </el-alert>
            <el-alert v-if="OfflineCommited" :title="OfflineMsg" type="warning" :closable="false">
            </el-alert>

            <div style="text-align: center;margin-top: 15px">
              <el-button v-if="!OfflineCommited" icon="el-icon-key" type="success"
                @click="GetOfflineCode">获取密码</el-button>
              <el-button v-if="OfflineCommited" icon="el-icon-key" type="warning"
                @click="GetOfflineCode">重新获取</el-button>
              <el-button :disabled="!OfflineCommited" style="margin-left: 25px" icon="el-icon-finished" type="success"
                @click="CommitOfflineCode">结束充次</el-button>
            </div>

          </el-form>
        </el-dialog>
        <!-- 离线充次 END -->

        <el-main>
          <div>
            <keep-alive>
              <component :is="taowa" :flag="flag"></component>
            </keep-alive>
          </div>
        </el-main>
      </el-container>
    </el-container>

    <div class="foot">Copyright © 2026 艾小晚设备管理平台 | 版本:C51B.Build   | 当前用户:{{ info.pg }}/{{ info.name }} | 最后登录时间:{{ info.login_time }}</div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Button } from 'element-ui'

Vue.use(Button)

export default {
  components: {
    devicecomp: (resolve) => require(['../components/devicecomp'], resolve),
    usercomp: (resolve) => require(['../components/usercomp.vue'], resolve),
    // couponcomp: (resolve) => require(['../components/couponcomp.vue'], resolve),
  },
  data() {
    return {
      pagetitle: '设备',
      activeIndex: "1",
      info: {},
      flag: '',
      taowa: 'devicecomp',
      // taowa: 'couponcomp',
      pg_list: {
        ui_device: false,
        offline_recharge: false,
        ui_userpage: false,
        create_user: false,
        // ui_coupon: false,
      },
      // 离线充次
      OfflineDialog: false,
      OfflineCommited: false,
      OfflineMsg: "",//
      OffCode: '',
      OffResult: '',
      OffOid: '',
      OffCid: '',
      OffName: '',

      ChargeCommited: false,
      // setting
      SettingDialog: false,
      InputOldPassword: "",
      InputPassword1: "",
      InputPassword2: "",
      InputOldOPPassword: "",
      InputNewOPPassword1: "",
      InputNewOPPassword2: "",
      OpForm: {
        user: ""
      }
    }
  },
  mounted() {

  },
  created() {
    this.info = this.$store.state.userInfo
    // console.log(this.info,"INFO")
    this.activeIndex = "2"
    this.PG_Query();
    let op = localStorage.getItem('op');
    if (op === null || op === '') {
      op = this.info.name;
      localStorage.setItem('op', op);
    }
    this.OpForm.user = op
  },
  beforeDestroy() {
  },
  methods: {

    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    // switchMainComp() {
    //   this.taowa = 'maincomp'
    //   this.pagetitle = '主页'
    //   this.activeIndex = "1"
    // },
    switchDeviceComp(sel, index) {
      console.log("sel", sel)
      this.flag = sel
      this.taowa = 'devicecomp'
      this.pagetitle = '设备'
      this.activeIndex = index
    },
    // switchCouponComp() {
    //   this.taowa = 'couponcomp'
    //   this.pagetitle = '用户管理'
    //   this.activeIndex = "3"
    // },
    switchUserComp() {
      this.taowa = 'usercomp'
      this.pagetitle = '账号'
      this.activeIndex = "5"
    },

    // switchServiceComp() {
    //   this.taowa = 'servicecomp'
    //   this.pagetitle = '售后'
    //   this.activeIndex = "4"
    // },
    async PG_Query() {
      let res = await this.$api.pg_query({
        pg: this.pg_list,
      })

      // console.log("pg ->", res)
      if (res.status == 1) {
        this.pg_list = res.data
      }

      console.log("====>", this.pg_list)
    },
    OPSave() {
      if (this.OpForm.user == "") {
        this.OpForm.user = this.info.name;
      }
      localStorage.setItem('op', this.OpForm.user);
      this.$message({
        message: '操作员已保存',
        type: 'success',
      })
    },
    openMap() {
      const url = `http://xydq.ai-zhineng.cn/map/#/?u=${this.info.uid}&t=${this.info.token}`;
      window.open(url, '_blank');
      // alert("正在开发中...")
    },
    openSetting() {
      let op = localStorage.getItem('op');
      if (op === null || op === '') {
        op = this.info.name;
        localStorage.setItem('op', op);
      }
      this.OpForm.user = op

      if (this.OpForm.user == "") {
        this.info.name
      }
      this.InputOldPassword = '';
      this.InputPassword1 = '';
      this.InputPassword2 = '';
      this.InputOldOPPassword = '';
      this.InputNewOPPassword1 = '';
      this.InputNewOPPassword2 = '';
      this.SettingDialog = true
    },
    // async ChangeOPPassword() {
    //   if (this.InputNewOPPassword1 === this.InputNewOPPassword2) {
    //     let res = await this.$api.change_op_password({
    //       uid: "" + this.info.uid,
    //       old: "" + this.InputOldOPPassword,
    //       pw: "" + this.InputNewOPPassword2,
    //     })
    //     console.log(res)
    //     if (res.status == 1) {
    //       this.$message({
    //         message: '锁机密码修改成功',
    //         type: 'success',
    //       })
    //     }
    //   } else {
    //     this.$notify({
    //       title: '错误',
    //       message: "两次输入新密码不一致",
    //       type: 'error',
    //     })
    //   }
    // },
    async ChangePassword() {
      if (this.InputPassword1 === this.InputPassword2) {
        let res = await this.$api.change_password_with_old({
          uid: "" + this.info.uid,
          old: "" + this.InputOldPassword,
          pw: "" + this.InputPassword1,
        })
        console.log(res)
        if (res.status == 1) {
          this.$message({
            message: '密码修改成功',
            type: 'success',
          })
        }
      } else {
        this.$notify({
          title: '错误',
          message: "两次输入密码不一致",
          type: 'error',
        })
      }
    },
    async CommitOfflineCode() {
      // let res = await this.$api.offline_confirm({
      //   cid: this.OffCid + "",
      //   oid: this.OffOid + "",
      // })
      // console.log(res)
      // if (res.status == 1) {
      //   this.$message({
      //     message: res.msg,
      //     type: 'success',
      //   })
      //   this.OfflineDialog = false
      //   this.onRefresh()
      // }
      this.OfflineDialog = false
    },
    async GetOfflineCode() {
      // let op = localStorage.getItem('op');
      // if (op === null || op === '') {
      //   op = this.info.name;
      //   localStorage.setItem('op', op);
      // }
      let res = await this.$api.offline_charge_norecord({
        offcode: this.OffCode + "",
        op: "",
      })
      console.log(res)
      if (res.status == 1) {
        this.OffResult = res.code
        this.OffCid = res.id3
        this.OffName = res.times
        this.OfflineMsg = res.msg
        this.OfflineCommited = true
      }
    },
    // 确认充次
    async RechargeConfirmCommit() {
      // this.RechargeTimesDialog = false
      let res = await this.$api.charge_confirm({
        sn: this.RechargeSN + "",
        oid: this.RechargeComfirmOid + "",
      })
      console.log(res)
      if (res.status == 1) {
        this.$message({
          message: res.msg,
          type: 'success',
        })
        this.RechargeTimesDialog = false
        this.onRefresh()
      }
    },
    exit() {
      this.$confirm('此操作将退出登陆, 是否继续?', '提示', {
        confirmButtonText: '确定退出',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$notify({
            title: '退出成功',
            message: '请重新登录',
            type: 'success',
          })
          window.sessionStorage.clear()
          this.$router.push('/login')
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消退出',
          })
        })
    },
  },
}
</script>

<style scoped>
.right {
  flex-wrap: wrap;
  display: flex;
  flex-direction: row;
  /* text-align: ce; */
  align-items: center;
  justify-content: space-between;
  margin-right: 25px;
}

.head {
  background-color: #135573;
  padding: 5px;
  padding-left: 30px;
  color: white;
  /* padding: 10px; */
}

.el-header {
  background-color: rgb(231, 244, 255);
  color: #333;
  line-height: 60px;
}

.el-aside {
  color: #333;
}

.foot {
  width: 100%;
  font-size: 14px;
  text-align: center;
}

/* .el-main {
  background: #eee;
} */
</style>
